import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

interface BreadcrumbItem {
    label: string;
    path?: string;
    onClick?: () => void;
}

interface BreadcrumbsProps {
    items: BreadcrumbItem[];
}

const Breadcrumbs: React.FC<BreadcrumbsProps> = ({ items }) => {
    const { i18n } = useTranslation();
    const isRtl = i18n.language === 'ar';

    return (
        <nav aria-label="breadcrumb" className="mb-4">
            <style>{`
                .breadcrumb-link:hover {
                    color: white !important;
                }
            `}</style>
            <ol className="breadcrumb">
                <li className="breadcrumb-item">
                    <Link to={`/${i18n.language}`} className="text-decoration-none text-secondary breadcrumb-link">
                        <i className="bi bi-house-door me-1"></i>
                    </Link>
                </li>
                {items.map((item, index) => {
                    const isLast = index === items.length - 1;
                    return (
                        <li
                            key={index}
                            className={`breadcrumb-item ${isLast ? 'active' : ''}`}
                            aria-current={isLast ? 'page' : undefined}
                        >
                            {isLast ? (
                                <span className="fw-bold text-dark">
                                    {item.label}
                                </span>
                            ) : item.onClick ? (
                                <button
                                    onClick={item.onClick}
                                    className="btn btn-link text-decoration-none text-primary p-0 border-0 align-baseline breadcrumb-link"
                                    style={{ verticalAlign: 'baseline' }}
                                >
                                    {item.label}
                                </button>
                            ) : item.path ? (
                                <Link to={item.path} className="text-decoration-none text-primary breadcrumb-link">
                                    {item.label}
                                </Link>
                            ) : (
                                <span className="text-secondary">
                                    {item.label}
                                </span>
                            )}
                        </li>
                    );
                })}
            </ol>
        </nav>
    );
};

export default Breadcrumbs;
